import { Action, ActionCreator } from 'redux';

export enum SystemUserManagementActionTypes {
    SYSTEM_USER_GROUP_SELECTION = 'SYSTEM_USER_GROUP_SELECTION',
    SYSTEM_ANNOUNCEMENT_SELECTION = 'SYSTEM_ANNOUNCEMENT_SELECTION',
}

export interface SystemUserGroupSelection extends Action {
    type: SystemUserManagementActionTypes.SYSTEM_USER_GROUP_SELECTION;
    payload: {
        systemUserGroupId: string;
        systemUserGroupName: string;
    };
}

export interface SystemAnnouncementSelection extends Action {
    type: SystemUserManagementActionTypes.SYSTEM_ANNOUNCEMENT_SELECTION;
    payload: {
        systemAnnouncementId: string;
    };
}

export type SystemUserManagementAction = SystemUserGroupSelection | SystemAnnouncementSelection;

export const selectSystemUserGroup: ActionCreator<SystemUserGroupSelection> = (systemUserGroupId: string, systemUserGroupName: string) => {
    return {
        type: SystemUserManagementActionTypes.SYSTEM_USER_GROUP_SELECTION,
        payload: {
            systemUserGroupId,
            systemUserGroupName,
        },
    };
};

export const selectSystemAnnouncement: ActionCreator<SystemAnnouncementSelection> = (systemAnnouncementId: string) => {
    return {
        type: SystemUserManagementActionTypes.SYSTEM_ANNOUNCEMENT_SELECTION,
        payload: {
            systemAnnouncementId,
        },
    };
};
